export var ComponentType;
(function (ComponentType) {
    ComponentType["Box"] = "box";
    ComponentType["Text"] = "text";
    ComponentType["Image"] = "image";
    ComponentType["TextButton"] = "textButton";
    ComponentType["ImageButton"] = "imageButton";
})(ComponentType || (ComponentType = {}));
